var _excluded = ["olSource", "olLayerRef"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import OlWMTSTileGrid from 'ol/tilegrid/WMTS';
import React, { Fragment, useEffect, useRef } from 'react';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';
import { getOptions } from '../utils';
var allVectorSourceOptions = {
  extent: undefined,
  origin: undefined,
  origins: undefined,
  resolutions: undefined,
  matrixIds: undefined,
  sizes: undefined,
  tileSize: undefined,
  tileSizes: undefined
};

var WMTSTileGrid = _ref => {
  var {
    olSource,
    olLayerRef
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var memoizedProps = useDeepCompareMemoize(props);
  var memoizedOptions = useDeepCompareMemoize(getOptions(Object.assign(allVectorSourceOptions, memoizedProps)));
  var tilegrid = useRef(null);
  useEffect(() => {
    tilegrid.current = new OlWMTSTileGrid(memoizedOptions);
  }, [memoizedOptions]);
  useEffect(() => {
    var _olLayerRef$current, _olSource$current;

    var projection = (_olLayerRef$current = olLayerRef.current) === null || _olLayerRef$current === void 0 ? void 0 : _olLayerRef$current.getProjection();
    if (projection && tilegrid.current) (_olSource$current = olSource.current) === null || _olSource$current === void 0 ? void 0 : _olSource$current.setTileGridForProjection(projection, tilegrid.current);
  }, [olLayerRef, olSource]);
  return /*#__PURE__*/React.createElement(Fragment, null);
};

export default WMTSTileGrid;